import HeaderAppBar from './HeaderAppBar';

export default function Header() {
  return <HeaderAppBar />;
}
